var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    {
      class: ["pack-card card with-shadow", { "margin-bottom-0": _vm.isLast }],
      staticStyle: {
        "--card-margin-bottom": "var(--spacing-2xl)",
        "--card-section-border":
          "var(--border-width-sm) solid var(--fa-lt-gravy)",
      },
      attrs: { id: `pack-card-${_vm.iconPack.name}` },
    },
    [
      _c("div", { staticClass: "section compact" }, [
        _c("div", { staticClass: "row align-middle" }, [
          _c(
            "div",
            {
              staticClass:
                "column-9 tablet:column display-flex flex-items-center",
              staticStyle: { gap: "var(--spacing-md)" },
            },
            [
              _c(
                "h3",
                {
                  staticClass: "size-lg text-uppercase margin-0",
                  staticStyle: {
                    "letter-spacing": "var(--letter-spacing-2xl)",
                    "--headings-font-weight": "var(--font-weight-black)",
                  },
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.iconPack.label) + "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("wa-tag", {
                attrs: {
                  if: "uxIsNew",
                  background: "var(--fa-navy)",
                  color: "var(--fa-blue)",
                  "is-rounded": "",
                  label: "New",
                },
              }),
              _vm._v(" "),
              _c("p", { staticClass: "size-sm muted" }, [
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v("This pack contains: "),
                ]),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.formattedCount(_vm.totalCount(_vm.familyStyles))
                    ) +
                    " Icons"
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isShowingIconPackViewLinks
            ? _c(
                "div",
                { staticClass: "column-3 tablet:column-3 text-right" },
                [
                  _c(
                    "site-link",
                    {
                      staticClass:
                        "size-sm button compact flat with-border margin-bottom-0",
                      staticStyle: {
                        "--button-font-weight": "var(--font-weight-normal)",
                      },
                      attrs: {
                        to: _vm.$pack({ name: _vm.iconPack.name }),
                        "aria-label": `Explore ${_vm.iconPack.label}`,
                        "data-balloon-pos": "left",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.$posthog.capture(
                            "icons_landing:pack_link_click",
                            { pack: _vm.iconPack.name }
                          )
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "display-none laptop:display-inline laptop:margin-right-4xs",
                        },
                        [_vm._v("Explore " + _vm._s(_vm.iconPack.label))]
                      ),
                      _vm._v(" "),
                      _c("font-awesome-icon", {
                        attrs: {
                          icon: _vm.$v6.solid.faArrowUpRight,
                          size: "lg",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm._l(_vm.familyStyles, function (familyStyle, index) {
        return _c(
          "site-link",
          {
            key: index,
            staticClass:
              "section no-underline pack-card-style position-relative display-flex flex-items-center",
            staticStyle: { gap: "var(--spacing-2xl)" },
            attrs: {
              to: _vm.$search({
                iconPacks: [_vm.iconPack.name],
                styles: [familyStyle.style],
              }),
            },
            nativeOn: {
              click: function ($event) {
                return _vm.$posthog.capture(
                  "icons_landing:pack_style_link_click",
                  {
                    pack: _vm.iconPack.name,
                    style: `${familyStyle.family} ${familyStyle.style}`,
                  }
                )
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "pack-card-style-details padding-right-5xl z-1" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "size-sm display-flex flex-items-center flex-content-center",
                    staticStyle: { gap: "var(--spacing-lg)", height: "100%" },
                  },
                  [
                    _c(
                      "h4",
                      {
                        staticClass: "h5 text-uppercase margin-0 text-nowrap",
                        staticStyle: {
                          color: "var(--fa-navy)",
                          "letter-spacing": "var(--letter-spacing-2xl)",
                          "--headings-font-weight": "var(--font-weight-black)",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(familyStyle.label) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "text-nowrap" }, [
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("This style contains: "),
                      ]),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.formattedCount(
                              _vm.familyStyleCount(familyStyle)
                            )
                          ) +
                          " Icons\n        "
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.featuredIcons, function (icon, i) {
              return _c("i", {
                key: i,
                class: _vm.iconClass({ ...familyStyle, icon: icon }),
              })
            }),
          ],
          2
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }